import { usePollAISuggestionRequest } from 'hooks/queries/articles/aiSuggestionsRequests/usePollAISuggestionRequest'
import { GenerateRequest, SuggestionRequestStatus } from 'types'
import { FC } from 'react'
import { observer } from 'mobx-react-lite'
import { useShowFailedGenerateRequestToast } from 'screens/ProseEdit/components/ProcessingSuggestionToast/useShowFailedGenerateRequestToast'
import { ErrorBoundary } from '@sentry/react'

interface Props {
  id: number
  articleId: string
  layerId: string
  onStreaming: (jobId: string) => any
  onStreamComplete: (generatedContent: string | null, status?: SuggestionRequestStatus) => any
}

const PollSuggestionRequest: FC<React.PropsWithChildren<Props>> = observer(
  ({ id, articleId, layerId, onStreaming, onStreamComplete }) => {
    const showFailedGenerateRequest = useShowFailedGenerateRequestToast()

    usePollAISuggestionRequest(
      {
        articleId,
        layerId,
        id,
      },
      {
        onSuccess: async ({ request }) => {
          const isFailed = request.status === SuggestionRequestStatus.Failed
          const isComplete = [
            SuggestionRequestStatus.Successful,
            SuggestionRequestStatus.Failed,
            SuggestionRequestStatus.Aborted,
          ].includes(request.status)

          if (!isComplete && request.job_id) {
            onStreaming(request.job_id)
          }

          if (isFailed) {
            showFailedGenerateRequest(request as unknown as GenerateRequest)
          }

          if (isComplete) {
            onStreamComplete(request.generated_content, request.status)
          }
        },
      },
    )

    return null
  },
)

const WithErrorBoundary = (props: Props) => (
  <ErrorBoundary>
    <PollSuggestionRequest {...props} />
  </ErrorBoundary>
)

export { WithErrorBoundary as PollSuggestionRequest }
